<template>
  <div class="majorProject">
    <div class="body-content">
      <div class="filter-box">
        <div class="filter-item" v-if="level==1">
          <div class="name">项目编号</div>
          <div class="value"><input type="text" v-model="number" class="input" placeholder="请输入相关字段，点击搜索"><span class="search-btn" @click="pageChange(1)">搜索</span></div>
        </div>
        <template v-else>
          <div class="filter-item">
            <div class="name"><span class="back-btn" @click="backLevel1">返回</span></div>
          </div>
          <div class="filter-item"
               v-for="(item1, index1) in filterData"
               :key="index1"
          >
            <div class="name">{{item1.type}}</div>
            <ul class="value">
              <li
                  v-for="(item2, index2) in item1.list"
                  :key="index2"
                  :class="{ active: item1.tabIndex === index2 }"
                  @click="toggleFilterItem(index1, index2)"
              >{{item2.label}}</li>
            </ul>
          </div>
        </template>
      </div>
    </div>

    <div class="body-content">
      <div class="main-content">
        <ul>
          <li v-for="project in projectList" :key="project.id">
            <div class="content">
              <img :src="fileUrl + project.coverImage" height="128"/>
              <div class="">
                <p class="name-box">
                  <span class="name pointer" @click="gotoLevel2(project.id)">{{project.name}}</span>
                  <span class="code">{{project.number}}</span>
                </p>
                <p style="-webkit-box-orient: vertical">{{project.content}}</p>
              </div>
            </div>
          </li>
        </ul>

        <div class="pagination-box">
          <el-pagination
            background
            layout="prev, pager, next, total"
            :total="page.total"
            @current-change="pageChange"
          >
          </el-pagination>
        </div>
      </div>
      <div class="majorProject-slidebar" v-if="level==1">
        <div class="slidebar-item">
          <div class="item-header">
            <span class="name line1">课题分布</span>
          </div>
          <div class="prev-icon" style="height: 300px;" id="lessonDistribution">
          </div>
        </div>
        <div class="slidebar-item">
          <div class="item-header">
            <span class="name line1">单位分布</span>
          </div>
          <div class="prev-icon" style="height: 300px; overflow: hidden;">
            <ul class="unit-area">
              <li><span>#</span><span>单位</span><span>数量</span></li>
              <li>
                <ul :style="'margin-top: -' + scrollIndex * 30 + 'px'">
                  <li v-for="(item,index) in unitCount" :key="index"><span>{{index+1}}</span><span>{{item.lead_unit}}</span><span>{{item.rs}}</span></li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="slidebar-item">
          <div class="item-header">
            <span class="name line1">经费分布</span>
          </div>
          <div class="prev-icon" style="height: 300px;" id="fundsDistribution">
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fileUrl: '',
      level: 1,
      projectList: [],
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      number: '',
      filterData: [
        {
          type: '成果展示',
          tabIndex: 0,
          list: [
            { label: '标准样品', value: '标准样品' },
            { label: '规程/规范', value: '规程/规范' },
            { label: '国际/国内比对', value: '国际/国内比对' },
            { label: '国际标准', value: '国际标准' },
            { label: '国际互认的测量和校准能力', value: '国际互认的测量和校准能力' },
            { label: '国家标准物质', value: '国家标准物质' },
            { label: '国内标准', value: '国内标准' },
            { label: '国内标准修改单', value: '国内标准修改单' },
            { label: '计量基标准', value: '计量基标准' },
            { label: '检测设备/仪器', value: '检测设备/仪器' },
            { label: '论文', value: '论文' },
            { label: '论著', value: '论著' },
            { label: '其他', value: '其他' },
            { label: '人才培养', value: '人才培养' },
            { label: '认证认可技术文件', value: '认证认可技术文件' },
            { label: '软件系统', value: '软件系统' },
            { label: '软件著作权', value: '软件著作权' },
            { label: '试点示范', value: '试点示范' },
            { label: '试验装置/系统', value: '试验装置/系统' },
            { label: '数据库', value: '数据库' },
            { label: '新技术/新方法', value: '新技术/新方法' },
            { label: '研究报告', value: '研究报告' },
            { label: '应用解决方案', value: '应用解决方案' },
            { label: '专利', value: '专利' },
            { label: '空白', value: '空白' },
            { label: '中国标准“走出去”', value: '中国标准“走出去”' }
          ]
        },
        {
          type: '成果类型',
          tabIndex: 0,
          list: [
            { label: '行业标准样品', value: '行业标准样品' },
            { label: '国家标准样品', value: '国家标准样品' }
          ]
        },
        {
          type: '行政区划',
          tabIndex: 0,
          list: [
            { label: '北京市', value: '北京市' },
            { label: '河北省', value: '河北省' },
            { label: '浙江省', value: '浙江省' },
            { label: '陕西省', value: '陕西省' },
            { label: '河南省', value: '河南省' },
            { label: '甘肃省', value: '甘肃省' },
            { label: '福建省', value: '福建省' },
            { label: '江苏省', value: '江苏省' },
            { label: '四川省', value: '四川省' },
            { label: '广东省', value: '广东省' },
            { label: '海南省', value: '海南省' },
            { label: '上海市', value: '上海市' },
            { label: '天津市', value: '天津市' },
            { label: '上海市', value: '上海市' },
            { label: '天津市', value: '天津市' },
            { label: '重庆市', value: '重庆市' },
            { label: '山东省', value: '山东省' },
            { label: '河北省', value: '河北省' },
            { label: '河南省', value: '河南省' },
            { label: '福建省', value: '福建省' },
            { label: '江苏省', value: '江苏省' },
            { label: '四川省', value: '四川省' },
            { label: '广东省', value: '广东省' },
            { label: '海南省', value: '海南省' },
            { label: '新疆维吾尔自治区', value: '新疆维吾尔自治区' },
            { label: '新疆维吾尔自治区', value: '新疆维吾尔自治区' },
            { label: '广西壮族自治区', value: '广西壮族自治区' },
            { label: '西藏自治区', value: '西藏自治区' },
            { label: '广西壮族自治区', value: '广西壮族自治区' }
          ]
        }
      ],
      lessonChart: null,
      unitCount: null,
      scrollIndex: 0,
      fundsChart: null
    }
  },
  created () {
    this.fileUrl = FileUrl;
    this.number = this.$route.query.keyWords;
    this.pageChange(1);
  },
  mounted () {
    this.fetchChartsData();
  },
  methods: {
    fetchList () {
      const _self = this;
      let queryParam = new FormData();
      if (_self.number) queryParam.append('number', _self.number);
      queryParam.append('pageNo', _self.page.pageNo);
      queryParam.append('pageSize', _self.page.pageSize);
      _self.post('/dataapi/open/nqi/project/likeList', queryParam).then(res => {
        _self.projectList = res.result.records;
        _self.page.total = res.result.total;
        document.body.scrollTop = document.documentElement.scrollTop = 0
      });
    },
    pageChange (current) {
      this.page.pageNo = current;
      this.fetchList();
    },
    toggleFilterItem (index1, index2) {
      this.filterData[index1].tabIndex = index2
    },
    gotoLevel2 (id) {
      // this.level = 2;
      this.$router.push({path: '/projectDetail', query: {id: id}});
    },
    backLevel1 () {
      this.level = 1;
    },
    fetchChartsData () {
      this.lessonChart = echarts.init(document.getElementById('lessonDistribution'));
      this.lessonChart.showLoading();
      this.fetch('/dataapi/open/nqi/project/getProjectCountByTask').then(res => {
        let result = res.result;
        result = result.sort((a, b) => { return Number(a.task_rs || 0) - Number(b.task_rs || 0) });
        let yAxis = [];
        let value = [];
        for (let item of result) {
          yAxis.push(item.task_rs || 0);
          value.push({
            itemStyle: {
              // color: `rgb(${Math.random()*255}, ${Math.random()*255}, ${Math.random()*255})`
              color: '#136bae'
            },
            value: item.task_rs_count
          });
        }
        this.lessonChart.setOption({
          xAxis: {
            name: '项目数',
            type: 'value',
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          yAxis: {
            name: '课题数',
            type: 'category',
            data: yAxis,
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          grid: {
            top: 40,
            bottom: 40,
            left: 60,
            right: 60
          },
          series: [
            {
              name: '课题分布',
              type: 'bar',
              label: {
                show: true
              },
              data: value
            }
          ]
        });
        this.lessonChart.hideLoading();
      });

      this.fetch('/dataapi/open/nqi/project/getProjectCountByUnit').then(res => {
        this.unitCount = res.result;
        const _self = this;
        setInterval(function () {
          _self.scrollIndex++;
          if (_self.scrollIndex + 9 === _self.unitCount.length) _self.scrollIndex = 0;
        }, 3000);
      });

      this.fundsChart = echarts.init(document.getElementById('fundsDistribution'));
      this.fundsChart.showLoading();
      this.fetch('/dataapi/open/nqi/project/getProjectCountByFee').then(res => {
        let result = res.result;
        let serieData = [];
        for (let item of result) {
          serieData.push([item.funds, item.specialFunds])
        }
        this.fundsChart.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            formatter: function (params) {
              return '总经费：' + params[0].data[0] + '<br/>' + params[0].seriesName + ' : ' + params[0].data[1];
            }
          },
          xAxis: {
            name: '总经费',
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          yAxis: {
            name: '中央专项经费',
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          grid: {
            top: 40,
            bottom: 40,
            left: 60,
            right: 60
          },
          series: [{
            name: '中央专项经费',
            symbolSize: 20,
            data: serieData,
            type: 'scatter'
          }]
        })
        this.fundsChart.hideLoading();
      });
    }
  }
}
</script>

<style lang="less">
.majorProject {
  .pagination-box {
    .el-pagination {
      button {
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
      }
    }
    .el-pager {
      .number {
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        font-size: 14px;
        font-family: HelveticaNeue;
        color: rgba(0, 0, 0, 0.65);
        font-weight: 400;
        &.active {
          background-color: rgba(46, 92, 154, 1)!important;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
.body-content {
  display: flex;
  width: @body-width;
  margin: 0 auto;
}
.majorProject {
  padding-top: 30px;
  .filter-box {
    width: 100%;
    padding: 14px 0;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    .filter-item {
      display: flex;
      padding: 10px 24px;
      border-bottom: 1px dashed rgba(0, 0, 0, .19);
      box-sizing: border-box;
      &:last-child {
        border-bottom: 0;
      }
      .name {
        flex: 0 0 4em;
        margin-right: 12px;
        font-size: 16px;
        color: rgba(0, 0, 0, .45);
        line-height: 50px;
        .back-btn {
          display: block;
          width: 60px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 16px;
          font-weight: 500;
          color: #2e5c9a;
          border: 1px solid #2e5c9a;
          cursor: pointer;
        }
      }
      .value {
        display: flex;
        flex-wrap: wrap;
        .input {
          margin: 0 10px 0 20px;
          width: 320px;
          height: 50px;
          outline: none;
          border: 1px solid rgba(0, 0, 0, 0.1);
          padding-left: 8px;
          box-sizing: border-box
        }
        .search-btn {
          width: 80px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 16px;
          font-weight: 500;
          color: #fff;
          background-color: #2e5c9a;
          cursor: pointer;
        }
        li {
          margin-left: 20px;
          padding: 2px 4px;
          font-size: 14px;
          color: rgba(0, 0, 0, .85);
          line-height: 20px;
          cursor: pointer;
          &.active {
            color: #fff;
            background-color: rgba(46, 92, 154, 1);
          }
        }
      }
    }
  }
  .main-content {
    flex: 1;
    margin-right: 24px;
    padding-top: 8px;
    ul {
      margin-bottom: 32px;
      li {
        padding: 24px 0 12px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .content {
          margin-bottom: 0;
          font-size: 14px;
          line-height: 28px;
          color: rgba(0, 0, 0, 0.65);
          display: flex;
          img {
            height: 128px;
            width: 200px;
            margin-right: 12px;
            transition: all 1s;
            &:hover {
              transform: scale(1.2);
            }
          }
          > div {flex: 1;}
          p {
            text-align: left;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            /* autoprefixer: off */
            -webkit-box-orient: vertical;
            /* autoprefixer: on */
            overflow: hidden;
            margin: 8px 0 8px 8px;
            font-size: 16px;
          }
          .name-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .name {
            font-size: 24px;
            font-weight: 500;
            line-height: 22px;
            color: rgba(46, 92, 154, 1);
          }
          .code {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.45);
            line-height: 17px;
          }
        }
      }
    }
    .pagination-box {
      padding-bottom: 60px;
      text-align: center;
    }
  }
  .majorProject-slidebar {
    flex: 0 0 400px;
    .slidebar-item {
      padding-top: 32px;
      .item-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 5px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .name {
          position: relative;
          padding-left: 12px;
          font-size: 24px;
          font-weight: 500;
          line-height: 33px;
          color: rgba(0, 0, 0, 1);
          &.line1::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            z-index: 1;
            transform: translateY(-50%);
            width: 2px;
            height: 16px;
            background-color: rgba(46, 92, 154, 1);
          }
          &.line2::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            z-index: 1;
            transform: translateY(-50%);
            width: 2px;
            height: 16px;
            background-color: rgba(170, 47, 51, 1);
          }
        }
        .more {
          font-size: 14px;
          color: rgba(143, 143, 143, 1);
          line-height: 20px;
          img {
            margin-left: 5px;
            width: 10px;
            vertical-align: middle;
          }
        }
      }
      ul {
        .text-item {
          padding: 16px 0 12px 0;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          .type-box {
            display: flex;
            align-items: flex-end;
            margin-bottom: 8px;
            span {
              &:nth-child(1) {
                margin-right: 8px;
                font-size: 16px;
                line-height: 22px;
                color: rgba(46, 92, 154, 1);
              }
              &:nth-child(2) {
                font-size: 12px;
                line-height: 17px;
                color: rgba(0, 0, 0, 0.45);
              }
            }
          }
          .text {
            font-size: 14px;
            line-height: 20px;
            color: rgba(0, 0, 0, 0.85);
          }
        }
        .image-item {
          padding-top: 12px;
          &:first-child {
            padding-top: 16px;
          }
          .image-box {
            width: 100%;
            height: 100px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .unit-area {
        > li:first-child {
          background-color: #136BAE;
          color: #ffffff;
        }
        > li:last-child {
          height: 270px;
        }
        li {
          position: relative;
          z-index: 1;
          height: 30px;
          line-height: 30px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          overflow: hidden;
          &:last-child {
            border-bottom: 0 none;
          }
          span:first-child {
            width: 60px;
            display: inline-block;
            text-align: center;
          }
          span:nth-child(2) {
            width: 280px;
            display: inline-block;
            white-space: nowrap;
          }
          span:nth-child(3) {
            width: 60px;
            display: inline-block;
            text-align: center;
          }
          ul {
            position: relative;
            z-index: 0;
            li:nth-child(2n + 1) {
              background-color: rgba(19, 107, 174, 0.2);
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/project/index.vue